import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'appfilter',
    pure: false
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], filter: any): any[] {
        if (!items || !filter) {
            return items;
        }
        return items.filter((item: any) => this.applyFilter(item, filter));
    }

    applyFilter(book: any, filter: any): boolean {
        //console.log('---');
        if (book.applnname.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
            return false;
        }
        return true;
    }
}
